// Scroll To

(function($) {

  var $ScrollItems;

  Formstone.Ready(function() {
    init();
  });

  function init() {
    $ScrollItems = $('.js-scroll_to, a[href*="#"]').not('.js-no_scroll_to, a[href*="#spu-"]').on('click', onScrollTo);
  }

  function onScrollTo(e) {
    var $target = $(e.delegateTarget);
    var id = $target[0].hash;
    var $to = $(id);

    if (
      e.target.pathname !== window.location.pathname ||
      e.target.hostname !== window.location.hostname ||
      e.target.protocol !== window.location.protocol ||
      e.target.search !== window.location.search
    ) {
      return;
    }

    if ($to.length) {
      e.preventDefault();
      e.stopPropagation();

      scrollToElement(id);

      $(document).trigger('scroll_to');
    }
  }

  function scrollToElement(selector) {
    var $to = $(selector);

    if ($to.length) {
      var offset = $to.offset();
      var margin = parseInt($to.css('scroll-margin-top'), 10);

      scrollToPosition(offset.top - margin);
    }
  }

  function scrollToPosition(top) {
    var offset = 0;

    $('html, body').animate({ scrollTop: top - offset });
  }

  //

  window.scrollToElement = scrollToElement;
  window.scrollToPosition = scrollToPosition;

})(jQuery);
